<template>
  <div class="paging flex_row">
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :current-page="currentPage"
      :page-size="pageSize"
      @current-change="onPageChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: "Paging",
  props: {
    pageSize: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
  created: function () {},
  mounted: function () {},

  methods: {
    //分页
    onPageChange(val) {
      this.$emit("onPageChange", val);
    },
  },
};
</script>
<style scoped>
.paging {
  margin: 87px 51px 61px;
  justify-content: flex-end;
}
.el-pagination {
  padding: 0px;
}
.paging >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1b63a7;
  border: 1px solid #1b63a7;
}
.paging >>> .el-pagination.is-background .btn-next,
.paging >>> .el-pagination.is-background .btn-prev,
.paging >>> .el-pagination.is-background .el-pager li {
  background-color: white;
  border: 1px solid #e8e8e8;
}
.paging >>> .el-pager li {
  line-height: 27px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/Paging.vue